import { createContext } from "react";
export const ListContext = createContext({
    listType: "ul",
    isNested: null,
    size: "medium",
});
//# sourceMappingURL=context.js.map